import { loadScript, seriParam, getQueryString } from './utils'
import Dajax from '@didi/dajax'

export const mountUserinfo = window.E.mountUserinfo = (userinfoObj) => {
    console.log('userinfoObj', userinfoObj)
    return new Promise((resolve, reject) => {
        try {
            if (userinfoObj) {
                sessionStorage.token = userinfoObj.token
                sessionStorage.phone = userinfoObj.phone
                window.E.phone = userinfoObj.phone
                window.E.tt = userinfoObj.token
                resolve(userinfoObj.phone)
            } else {
                resolve()
            }
        } catch (error) {
            reject(error)
        }
    })
}
const fetchPartnerId = window.E.fetchPartnerId = (phone) => {
    console.log(phone)
    // return Dajax.request({
    //     url: '//pre04-es.xiaojukeji.com/activity/PartnerV3/checkCode',
    //     method: 'post',
    //     // emulateJSON: true, // 是否使用application/x-www-form-urlencoded来提交
    //     headers: {
    //         'Content-Type': 'application/x-www-form-urlencoded'
    //     },
    //     // withCredentials: true,
    //     needEncrypt: true, // 是否加签名
    //     body: {
    //         phone
    //     }
    // }).then(response => response.json())
    return Dajax.post('https://es.xiaojukeji.com/activity/PartnerV3/checkCode', {
        phone
    }, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        needEncrypt: true
    }).then(response => response.json())
    // return Dajax.post('/gaea/company/promotion/getAuthAndRecharge', params).then(response => response.json())
}
const fetchCreateJsapiSignature = window.E.fetchCreateJsapiSignature = (url) => {
    console.log(url)
    return Dajax.get(`//eos-marketing.es.xiaojukeji.com/api/eos/v2/weixin/createJsapiSignature?url=${url}`).then(response => response.json())
    // return Dajax.post('/gaea/company/promotion/getAuthAndRecharge', params).then(response => response.json())
}
const getAccountInfo = window.E.getAccountInfo = (phone, strategyId, token) => {
    console.log('phone, strategyId---------------', phone, strategyId, token)
    return Dajax.post('//eos-marketing.es.xiaojukeji.com/api/v2/rule/recommender/reward/total', {
        phone,
        token,
        activityId: strategyId
    }).then(response => response.json())
    // return Dajax.post('/gaea/company/promotion/getAuthAndRecharge', params).then(response => response.json())
}
window.E.alertDialog = (msg, showClose) => {
    document.body.style.overflow = 'hidden'
    const msgHtml = `<div style="width:100%;height:100%;position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,0.4);z-index:1000;">
        <div style="background:#fff;font-size:14px;color:#666;text-align:center;width:240px;position: relative;top: 50%;left: 50%;transform: translate(-50%, -50%);">
            <div style="padding:10px 15px;">
                <img src="https://es-static.xiaojukeji.com/static/web/do1_lFN6P7TZamwnFXpKRIzJ" style="display:block;width:50px;margin:0 auto;">
                <div style="margin-top:10px;">${msg}</div>
            </div>${showClose ? '<div style="width:100%;height:40px;line-height:40px;text-align:center;border-top:1px solid #f3f3f3;" id="closeClick">我知道了</div>' : ''} 
        </div>
    </div>`
    const _html = document.createElement('div')
    _html.innerHTML = msgHtml
    document.body.appendChild(_html)
    if (showClose) {
        document.getElementById('closeClick').addEventListener('click', function () {
            document.body.style.overflow = ''
            document.body.removeChild(_html)
        })
    }
}
// const fusionUrl = '//es-static.xiaojukeji.com/static/web/home/js/sdk/fusion-1-286cd68b73.0.7.js'
// const ESBridge = '//es-static.xiaojukeji.com/static/web/home/js/jimuBridge1-fb3f0df48f.4.1.js'
const WXJsUrl = '//res.wx.qq.com/open/js/jweixin-1.6.0.js'
const appEnvObj = {
    isDidiESApp: window.navigator.userAgent.toLocaleLowerCase().indexOf('didies') > -1,
    isDidiApp: window.navigator.userAgent.toLocaleLowerCase().indexOf('didi.passenger') > -1,
    isWx: window.navigator.userAgent.toLocaleLowerCase().indexOf('micromessenger') > -1,
    isWxMiniApp: (
        window.navigator.userAgent.toLocaleLowerCase().indexOf('miniprogram') > -1 && window.navigator.userAgent.toLocaleLowerCase().indexOf('micromessenger') > -1
    )
}
const setShareRecommend = (DiDiShareConfig, EsShareConfig, WxMessageShareConfig, WxTimeLineShareConfig) => {
    console.log('setShareRecommend')
    console.log('DiDiShareConfig, EsShareConfig, WxMessageShareConfig, WxTimeLineShareConfig', DiDiShareConfig, EsShareConfig, WxMessageShareConfig, WxTimeLineShareConfig)
    return new Promise((resolve, reject) => {
        try {
            if (appEnvObj.isDidiApp) {
                window.D.setShare(DiDiShareConfig)
                resolve()
            } else if (appEnvObj.isDidiESApp) {
                console.log('EsShareConfig-recommend', EsShareConfig)
                window.bridgeApi.updateRightIcon(1)
                window.bridgeApi.rightNavButtonClicked(function () {
                    window.bridgeApi.commonShare(EsShareConfig)
                })
                resolve()
            } else if (appEnvObj.isWxMiniApp) {
                loadScript(WXJsUrl, function () {
                    // web-view下的页面内
                    function ready () {
                        window.wx.miniProgram.postMessage({
                            data: {
                                type: 'share',
                                data: {
                                    title: WxTimeLineShareConfig.title || '好友@您加入滴滴企业版',
                                    url: WxTimeLineShareConfig.link,
                                    imageUrl: WxTimeLineShareConfig.imgUrl || 'https://s3-gz01.didistatic.com/packages-mait/img/5v0FTk1yuW1741834141908.png'
                                }
                            }
                        })
                        resolve()
                    }
                    if (!window.WeixinJSBridge || !window.WeixinJSBridge.invoke) {
                        document.addEventListener('WeixinJSBridgeReady', ready, false)
                    } else {
                        ready()
                    }
                })
            } else if (appEnvObj.isWx) {
                loadScript(WXJsUrl, () => {
                    fetchCreateJsapiSignature(encodeURIComponent(window.location.href)).then((data) => {
                        window.wx.config({
                            // 开启调试模式,调用的所有api的返j回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                            // debug: true,
                            appId: data.data.appId, // 必填，公众号的唯一标识
                            timestamp: data.data.timestamp, // 必填，生成签名的时间戳
                            nonceStr: data.data.nonceStr, // 必填，生成签名的随机串
                            signature: data.data.signature, // 必填，签名
                            jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表
                        })
                        window.wx.ready(() => {
                            // console.log('88888888888888888888', WxMessageShareConfig, window.wx.updateAppMessageShareData(WxMessageShareConfig), window.wx.updateTimelineShareData(WxTimeLineShareConfig))
                            window.wx.updateAppMessageShareData(WxMessageShareConfig)
                            window.wx.updateTimelineShareData(WxTimeLineShareConfig)
                        })
                        resolve()
                    })
                })
            } else {
                resolve()
            }
        } catch (error) {
            reject(error)
        }
    })
}
export const initPartnerSet = window.E.initPartnerSet = (phone) => {
    console.log('initPartnerSet', phone)
    return new Promise((resolve, reject) => {
        if (phone) {
            fetchPartnerId(phone).then((res) => {
                console.log('fetchPartnerId', res)
                if (res.status === 0) {
                    sessionStorage.partnerId = res.data.partner_id
                    window.E.partnerId = res.data.partner_id
                    resolve({ phone, partnerId: res.data.partner_id })
                } else {
                    window.E.alertDialog((res.msg[0] && res.msg[0].msg) || '获取推荐人Id失败', true)
                }
            })
        } else {
            resolve()
        }
    })
}
const updateConfig = function (configObj, appName, userInfo, shareUrl) {
    const queryDataU = getQueryString()
    console.log('queryDataU----------', queryDataU, window.strategyId, window.recommend_business_line)
    delete queryDataU.s
    delete queryDataU.phone
    const recommendKeyParams = userInfo ? {
        phone: userInfo.phone,
        partner_id: userInfo.partnerId,
        paramsJson: encodeURIComponent(JSON.stringify({ strategyId: window.strategyId, recommend_business_line: window.recommend_business_line }))
    } : {}
    const newQueryDataStr = seriParam(Object.assign({}, recommendKeyParams, queryDataU, {
        referee: 1
    }))
    console.log('newQueryDataStr333', newQueryDataStr)
    const recommendFlag = shareUrl.indexOf('?') > -1
    console.log('recommendFlag', recommendFlag)
    if (appName === 'wx' || appName === 'wxTL') {
        return Object.assign({}, configObj, {
            link: recommendFlag ? `${window.E.EsShareConfig.share_url}&${newQueryDataStr}` : `${window.E.EsShareConfig.share_url}?${newQueryDataStr}`
        })
    } else if (appName === 'didi') {
        return Object.assign({}, configObj, {
            url: recommendFlag ? `${window.E.EsShareConfig.share_url}&${newQueryDataStr}` : `${window.E.EsShareConfig.share_url}?${newQueryDataStr}`
        })
    } else if (appName === 'es') {
        return Object.assign({}, configObj, {
            share_url: recommendFlag ? `${window.E.EsShareConfig.share_url}&${newQueryDataStr}` : `${window.E.EsShareConfig.share_url}?${newQueryDataStr}`
        })
    }
}
export const setShareConfig = window.E.setShareConfig = (userInfo) => {
    console.log('setShareConfig', userInfo, window)
    return new Promise((resolve, reject) => {
        const HOME_URL = window.shareUrl
        const shareTitle = window.__shareData ? window.__shareData.title : '快开通滴滴企业版，限时活动进行中'
        const shareContent = window.__shareData ? window.__shareData.content : '企业服务选滴滴，省时省力更省钱，首充限时最高返22000元券！'
        const shareIcon = window.__shareData ? (window.__shareData.icon.indexOf('http:') > -1 ? window.__shareData.icon.replace('http:', 'https:') : window.__shareData.icon) : 'https://es-static.xiaojukeji.com/static/web/do1_Np52EhEERVEJe7ZxwLuZ'
        const shareCardIcon = window.__shareData ? (window.__shareData.shareCardIcon.indexOf('http:') > -1 ? window.__shareData.shareCardIcon.replace('http:', 'https:') : window.__shareData.shareCardIcon) : 'https://s3-gz01.didistatic.com/packages-mait/img/5v0FTk1yuW1741834141908.png'
        const shareCardContent = window.__shareData ? window.__shareData.shareCardContent : '好友@您加入滴滴企业版，首充最高返32000元！'
        const baseShareConfig = {
            weixin_appmsg: true,
            weixin_timeline: true,
            qq_appmsg: false,
            qzone: false,
            alipay_appmsg: false,
            alipay_timeline: false,
            ding_talk: false
        }
        const DiDiShareConfig = Object.assign({}, baseShareConfig, {
            url: HOME_URL,
            title: shareTitle,
            content: shareContent,
            icon: shareIcon
        })
        const EsShareConfig = Object.assign({}, baseShareConfig, {
            share_url: HOME_URL,
            share_url_origin: HOME_URL,
            share_title: shareTitle,
            share_content: shareContent,
            share_picture: shareIcon,
            share_channel: '1,2'
        })
        const WxMessageShareConfig = Object.assign({}, baseShareConfig, {
            title: shareTitle,
            desc: shareContent,
            link: HOME_URL, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: shareIcon
        })
        const WxTimeLineShareConfig = Object.assign({}, baseShareConfig, {
            title: shareCardContent, // 分享标题
            link: HOME_URL, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: shareCardIcon // 分享图标
        })
        window.E.EsShareConfig = EsShareConfig
        // if (userInfo) {
        const afterDiDiShareConfig = updateConfig(DiDiShareConfig, 'didi', userInfo, HOME_URL)
        const afterEsShareConfig = updateConfig(EsShareConfig, 'es', userInfo, HOME_URL)
        const afterWxMessageShareConfig = updateConfig(WxMessageShareConfig, 'wx', userInfo, HOME_URL)
        const afterWxTimeLineShareConfig = updateConfig(WxTimeLineShareConfig, 'wxTL', userInfo, HOME_URL)
        afterEsShareConfig && (window.E.EsShareConfig = afterEsShareConfig)
        if (userInfo) {
            console.log('userInfo.phone-----------userInfo.phone', userInfo.phone, window.strategyId)
            getAccountInfo(userInfo.phone, window.strategyId, window.E.tt).then((res) => {
                console.log('getAccountInfo', res)
                if (res.status === 0) {
                    window.E.accountNum = res.data.totalAmount
                    resolve(true)
                } else {
                    window.E.alertDialog(res.msg || '获取进度信息有误', true)
                    resolve(false)
                }
            })
            if (!(appEnvObj.isDidiESApp || appEnvObj.isDidiApp || appEnvObj.isWx || appEnvObj.isWxMiniApp)) {
                try {
                    window.history.replaceState(null, null, afterEsShareConfig.share_url)
                } catch (e) {
                    console.log('err', e)
                }
            }
        } else {
            resolve(false)
        }
        window.bridgeApi && window.bridgeApi.updateRightIcon(0)
        console.log(afterDiDiShareConfig, afterEsShareConfig, afterWxMessageShareConfig, afterWxTimeLineShareConfig)
        setShareRecommend(afterDiDiShareConfig, afterEsShareConfig, afterWxMessageShareConfig, afterWxTimeLineShareConfig)
    })
    // const { DiDiShareConfig, EsShareConfig, WxMessageShareConfig, WxTimeLineShareConfig, phone ,queryData,window.E.EsShareConfig.share_url,isDidiESApp,isDidiApp,isWx,isWxMiniApp} = this.state
}
